(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-lespoir"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-story')) {
    customElements.define(
      'about-story',
      class AboutStory extends HTMLElement {
        connectedCallback() {
          this.hero = this.querySelector('.ab-hero');
          this.heroMedia = this.querySelector('[data-parallax]');
          this.body = this.querySelector('.ab-body');
          this.reveals = Array.from(this.querySelectorAll('.reveal'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (this.reducedMotion.matches) {
            this.reveals.forEach((el) => el.classList.add('is-visible'));
            this.style.setProperty('--p', '1');
            return;
          }

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  this.io.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.18, rootMargin: '0px 0px -10% 0px' }
          );
          this.reveals.forEach((el) => this.io.observe(el));

          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => { this.update(); this.ticking = false; });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          if (this.io) this.io.disconnect();
        }

        update() {
          const vh = window.innerHeight || document.documentElement.clientHeight;

          if (this.hero && this.heroMedia) {
            const r = this.hero.getBoundingClientRect();
            if (r.bottom > 0 && r.top < vh) {
              const shift = Math.max(0, -r.top) * 0.18;
              this.heroMedia.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
            }
          }

          if (this.body) {
            const r = this.body.getBoundingClientRect();
            let p = (vh * 0.55 - r.top) / r.height;
            p = Math.min(1, Math.max(0, p));
            this.style.setProperty('--p', p.toFixed(3));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.luxury-showcase__tile').forEach(function (tile) {
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect();
        tile.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        tile.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('discovery-video')) {
    customElements.define(
      'discovery-video',
      class DiscoveryVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.soundBtn = this.querySelector('[data-sound]');
          this.soundLabel = this.querySelector('[data-sound-label]');
          this.playBtn = this.querySelector('[data-play]');
          this.section = this.closest('[data-ld]');
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.userPaused = this.reduced;
          this.inView = false;

          if (this.section && !this.reduced && 'IntersectionObserver' in window) {
            this.section.classList.add('is-armed');
            const revealIo = new IntersectionObserver((entries) => {
              if (entries[0].isIntersecting) {
                this.section.classList.add('is-visible');
                revealIo.disconnect();
              }
            }, { threshold: 0.2 });
            revealIo.observe(this.section);
          }

          // alleen afspelen in beeld; buiten beeld pauzeren (ook het geluid)
          this.io = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.35 });
          this.io.observe(this);

          this.soundBtn.addEventListener('click', () => {
            const on = this.video.muted;
            this.video.muted = !on;
            if (on) {
              this.video.volume = 1;
              this.userPaused = false;
            }
            this.updateUi();
            this.sync();
          });

          this.playBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.updateUi();
            this.sync();
          });

          this.video.addEventListener('timeupdate', () => {
            if (this.video.duration) {
              this.style.setProperty('--vp', (this.video.currentTime / this.video.duration).toFixed(4));
            }
          });

          document.addEventListener('visibilitychange', () => this.sync());
          this.updateUi();
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }

        sync() {
          const shouldPlay = this.inView && !this.userPaused && !document.hidden;
          if (shouldPlay && this.video.paused) {
            const p = this.video.play();
            if (p && p.catch) {
              p.catch(() => {
                // browser blokkeert afspelen met geluid: val terug op gedempt
                if (!this.video.muted) {
                  this.video.muted = true;
                  this.updateUi();
                  this.video.play().catch(() => {});
                }
              });
            }
          } else if (!shouldPlay && !this.video.paused) {
            this.video.pause();
          }
        }

        updateUi() {
          const soundOn = !this.video.muted;
          this.soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          this.soundLabel.textContent = soundOn ? this.soundBtn.dataset.labelOff : this.soundBtn.dataset.labelOn;
          this.classList.toggle('is-paused', this.userPaused);
          this.playBtn.setAttribute('aria-label', this.userPaused ? this.playBtn.dataset.labelPlay : this.playBtn.dataset.labelPause);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-editorial]').forEach(function (section) {
      section.classList.add('is-armed');
      var io = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            section.classList.add('is-visible');
            io.disconnect();
          }
        },
        { threshold: 0.2 }
      );
      io.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-fragrance-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fragrance-finder')) {
    customElements.define(
      'fragrance-finder',
      class FragranceFinder extends HTMLElement {
        connectedCallback() {
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.questions = Array.from(this.querySelectorAll('[data-question]'));
          this.stars = Array.from(this.querySelectorAll('[data-star]'));
          this.stepEl = this.querySelector('[data-step]');
          this.echoEl = this.querySelector('[data-echo-out]');
          this.backBtn = this.querySelector('[data-back]');
          this.total = this.questions.length;
          this.order = ['blanche', 'rouge', 'noir'];
          this.timers = [];

          this.querySelector('[data-start]').addEventListener('click', () => this.start());
          this.querySelector('[data-restart]').addEventListener('click', () => this.restart());
          this.backBtn.addEventListener('click', () => this.goBack());

          this.querySelectorAll('.ff__option').forEach((opt) => {
            opt.addEventListener('click', () => this.choose(opt));
            const on = () => (this.dataset.hover = opt.dataset.scent);
            const off = () => delete this.dataset.hover;
            opt.addEventListener('pointerenter', on);
            opt.addEventListener('pointerleave', off);
            opt.addEventListener('focus', on);
            opt.addEventListener('blur', off);
          });

          this.reset();
        }

        disconnectedCallback() {
          this.clearTimers();
        }

        wait(ms, fn) {
          if (this.reduced) ms = Math.min(ms, 60);
          this.timers.push(setTimeout(fn, ms));
        }

        clearTimers() {
          this.timers.forEach(clearTimeout);
          this.timers = [];
        }

        setState(state) {
          this.dataset.state = state;
        }

        reset() {
          this.index = 0;
          this.scores = { blanche: 0, rouge: 0, noir: 0 };
          this.history = [];
          delete this.dataset.win;
          delete this.dataset.hover;
          this.updateEssence();
        }

        start() {
          this.clearTimers();
          this.reset();
          this.classList.add('is-breaking');
          this.wait(650, () => {
            this.classList.remove('is-breaking');
            this.setState('quiz');
            this.render();
          });
        }

        restart() {
          this.clearTimers();
          this.reset();
          this.setState('intro');
          this.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
        }

        // de essences: elk antwoord laat de bijpassende groeien en trekt ze samen
        updateEssence() {
          const sum = this.scores.blanche + this.scores.rouge + this.scores.noir;
          this.order.forEach((k) => {
            const share = (this.scores[k] + 1) / (sum + 3);
            this.style.setProperty('--w-' + k, share.toFixed(3));
          });
          this.style.setProperty('--conv', (this.history.length / this.total * 0.55).toFixed(3));
        }

        render() {
          this.questions.forEach((q, i) => {
            const active = i === this.index;
            q.hidden = !active;
            q.classList.remove('is-answered', 'is-leaving');
            q.querySelectorAll('.ff__option').forEach((o) => o.classList.remove('is-chosen'));
          });
          this.echoEl.classList.remove('is-visible');
          this.stars.forEach((s, i) => {
            s.classList.toggle('is-lit', i < this.history.length);
            s.classList.toggle('is-current', i === this.index);
          });
          this.style.setProperty('--lines', Math.max(0, this.history.length - 1));
          this.stepEl.textContent = (this.dataset.stepLabel || '')
            .replace('%1', this.index + 1)
            .replace('%2', this.total);
          this.backBtn.hidden = this.index === 0;
          const first = this.questions[this.index].querySelector('.ff__option');
          if (first && this.started) first.focus({ preventScroll: true });
          this.started = true;
        }

        choose(opt) {
          const q = this.questions[this.index];
          if (q.classList.contains('is-answered')) return;
          const scent = opt.dataset.scent;
          const weight = parseInt(opt.dataset.weight, 10) || 1;
          this.history.push({ scent: scent, weight: weight, why: opt.dataset.why });
          this.scores[scent] += weight;

          q.classList.add('is-answered');
          opt.classList.add('is-chosen');
          this.stars[this.index].classList.add('is-lit');
          this.style.setProperty('--lines', Math.max(0, this.history.length - 1));
          this.updateEssence();

          // het antwoord laat los, de echo verschijnt, dan de volgende vraag
          this.wait(450, () => {
            q.classList.add('is-leaving');
            this.echoEl.textContent = opt.dataset.echo || '';
            this.echoEl.classList.add('is-visible');
          });
          this.wait(2100, () => {
            delete this.dataset.hover;
            if (this.index < this.total - 1) {
              this.index += 1;
              this.render();
            } else {
              this.reveal();
            }
          });
        }

        goBack() {
          if (this.index === 0) return;
          this.clearTimers();
          const last = this.history.pop();
          if (last) this.scores[last.scent] -= last.weight;
          this.index -= 1;
          this.updateEssence();
          this.render();
        }

        ranking() {
          const tieScent = this.history[1] && this.history[1].scent;
          return this.order.slice().sort((a, b) => {
            const d = this.scores[b] - this.scores[a];
            if (d !== 0) return d;
            // gelijkspel: de gewogen sfeervraag beslist
            if (a === tieScent) return -1;
            if (b === tieScent) return 1;
            return this.order.indexOf(a) - this.order.indexOf(b);
          });
        }

        reveal() {
          const rank = this.ranking();
          const win = rank[0];
          this.dataset.win = win;
          this.echoEl.classList.remove('is-visible');
          this.stars.forEach((s) => s.classList.add('is-lit'));
          this.style.setProperty('--lines', 3);

          this.querySelectorAll('[data-result]').forEach((card) => {
            card.hidden = card.dataset.result !== win;
          });
          this.querySelectorAll('[data-second]').forEach((a) => {
            a.hidden = a.dataset.second !== rank[1];
          });

          // persoonlijke reden: de antwoorden die bij de winnende geur horen
          const whys = this.history.filter((h) => h.scent === win).map((h) => h.why);
          const card = this.querySelector('[data-result="' + win + '"]');
          const reasonEl = card && card.querySelector('[data-reason]');
          if (reasonEl) {
            reasonEl.textContent = whys.length > 1
              ? (this.dataset.reasonTwo || '').replace('%1', whys[0]).replace('%2', whys[1])
              : (this.dataset.reasonOne || '').replace('%1', whys[0] || '');
          }

          this.setState('reveal');
          this.wait(2600, () => {
            this.setState('result');
            const top = this.getBoundingClientRect().top;
            if (top < -40 || top > window.innerHeight * 0.3) {
              this.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applySpeed(video) {
      var rate = parseFloat(video.getAttribute('data-speed')) || 1;
      var set = function () {
        if (Math.abs(video.playbackRate - rate) > 0.001) {
          video.playbackRate = rate;
        }
      };
      set();
      video.addEventListener('loadedmetadata', set);
      video.addEventListener('play', set);
      video.addEventListener('ratechange', set);
    }

    var videos = document.querySelectorAll('.luxury-hero__video-el, .luxury-hero__media video');
    for (var i = 0; i < videos.length; i++) {
      applySpeed(videos[i]);
    }

    // Dageraad-overgang: scroll-voortgang als --hp (0..1). Alleen transform/opacity,
    // rAF-gethrottled en alleen actief zolang de hero in beeld is.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroes = document.querySelectorAll('.luxury-hero');
    Array.prototype.forEach.call(heroes, function (hero) {
      var ticking = false;
      var active = true;
      var update = function () {
        ticking = false;
        var rect = hero.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
        hero.style.setProperty('--hp', p.toFixed(4));
      };
      var onScroll = function () {
        if (!active || ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          active = entries[0].isIntersecting;
          if (active) onScroll();
        }).observe(hero);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    document.querySelectorAll('.lx-manifesto [data-reveal]').forEach(function (el) {
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-parallax-quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.25 }
    );
    document.querySelectorAll('.lx-parallax [data-reveal]').forEach(function (el) {
      io.observe(el);
    });

    if (reduce) return;
    document.querySelectorAll('[data-parallax]').forEach(function (section) {
      var media = section.querySelector('[data-parallax-media]');
      if (!media) return;
      var ticking = false;
      var range = 90; // px of travel
      function update() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > vh) {
          ticking = false;
          return;
        }
        // progress: 0 when section enters bottom, 1 when it leaves top
        var progress = (vh - rect.top) / (vh + rect.height);
        var offset = (progress - 0.5) * range * 2;
        media.style.setProperty('--py', offset.toFixed(1) + 'px');
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-quote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quote-rotator')) {
    customElements.define(
      'quote-rotator',
      class QuoteRotator extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.bar = this.querySelector('[data-progress]');
          this.current = 0;
          this.timer = null;
          this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (this.slides.length < 2) return;

          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              this.goTo(index);
              this.restart();
            });
          });

          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              this.stop();
            } else {
              this.start();
            }
          });

          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        goTo(index) {
          const prev = this.slides[this.current];
          prev.classList.remove('is-active');
          prev.setAttribute('aria-hidden', 'true');
          if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

          this.current = (index + this.slides.length) % this.slides.length;

          const next = this.slides[this.current];
          next.classList.add('is-active');
          next.removeAttribute('aria-hidden');
          if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');

          this.runProgress();
        }

        runProgress() {
          if (!this.bar || this.reducedMotion.matches) return;
          this.bar.style.animation = 'none';
          void this.bar.offsetWidth;
          this.bar.style.animation = 'lxProg ' + this.speed + 'ms linear forwards';
        }

        start() {
          if (this.timer || this.reducedMotion.matches) return;
          this.runProgress();
          this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
          if (this.bar) this.bar.style.animationPlayState = 'paused';
        }

        restart() {
          this.stop();
          this.start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-signature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('signature-reveal')) {
    customElements.define(
      'signature-reveal',
      class SignatureReveal extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          // Kop: op elk scherm onthullen (gouden lijnen, script-woord dat "geschreven" wordt).
          const head = this.querySelector('.lx-sig__head');
          if (head) {
            this.classList.add('is-head-armed');
            this.headObserver = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                requestAnimationFrame(() => this.classList.add('is-head-visible'));
                this.headObserver.disconnect();
              },
              { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
            );
            this.headObserver.observe(head);
          }

          // Kaarten alleen op desktop: op mobiel is de rij horizontaal scrollbaar en moet
          // de volgende kaart meteen zichtbaar "doorkijken" als swipe-hint.
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          const items = this.querySelectorAll('.lx-sig__item');
          this.classList.add('is-armed');
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
          );
          items.forEach((item) => this.observer.observe(item));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.headObserver) this.headObserver.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxury-slideshow')) {
    customElements.define(
      'luxury-slideshow',
      class LuxurySlideshow extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.current = 0;
          this.timer = null;
          this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (this.slides.length < 2) return;

          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              this.goTo(index);
              this.restart();
            });
          });

          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              this.stop();
            } else {
              this.start();
            }
          });

          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        goTo(index) {
          this.slides[this.current].classList.remove('is-active');
          this.slides[this.current].setAttribute('aria-hidden', 'true');
          if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

          this.current = (index + this.slides.length) % this.slides.length;

          this.slides[this.current].classList.add('is-active');
          this.slides[this.current].removeAttribute('aria-hidden');
          if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
        }

        start() {
          if (this.timer || this.reducedMotion.matches) return;
          this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        restart() {
          this.stop();
          this.start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hope-story')) {
    customElements.define(
      'hope-story',
      class HopeStory extends HTMLElement {
        connectedCallback() {
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.tabs = Array.from(this.querySelectorAll('.hope__tab'));
          this.panels = Array.from(this.querySelectorAll('.hope__panel'));
          this.chapters = this.querySelector('[data-chapters]');
          this.toggleBtn = this.querySelector('[data-toggle]');
          this.index = 0;
          this.elapsed = 0;
          this.userPaused = this.reduced;
          this.holds = new Set();
          this.inView = false;

          this.classList.add('is-ready');
          if (this.userPaused) this.classList.add('is-paused');
          this.setToggleLabel();

          // leestijd per hoofdstuk: ~0,38 s per woord, minimaal 9 s, maximaal 24 s
          this.durations = this.panels.map((p) => {
            const words = p.textContent.trim().split(/\s+/).length;
            return Math.min(24000, Math.max(9000, words * 380));
          });

          this.lineObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                this.lineObserver.unobserve(entry.target);
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -6% 0px' }
          );
          this.querySelectorAll('.hope__line').forEach((el) => this.lineObserver.observe(el));

          this.viewObserver = new IntersectionObserver(
            (entries) => {
              this.inView = entries[0].isIntersecting;
              if (this.inView) this.resume();
            },
            { threshold: 0.35 }
          );
          this.viewObserver.observe(this.chapters);

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.go(i));
            tab.addEventListener('keydown', (e) => {
              if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
                this.go(next);
                this.tabs[next].focus();
              }
            });
          });
          this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1));
          this.toggleBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.classList.toggle('is-paused', this.userPaused);
            this.setToggleLabel();
            if (!this.userPaused) this.resume();
          });

          // pauzeer tijdens lezen met de muis erop of met focus erin
          const hold = (key, on) => {
            if (on) this.holds.add(key);
            else this.holds.delete(key);
            if (!on) this.resume();
          };
          const panelsEl = this.querySelector('[data-panels]');
          panelsEl.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hold('hover', true); });
          panelsEl.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') hold('hover', false); });
          // alleen toetsenbordfocus pauzeert; een klik/tik op een knop niet
          this.chapters.addEventListener('focusin', (e) => {
            if (e.target.matches(':focus-visible')) hold('focus', true);
          });
          this.chapters.addEventListener('focusout', () => hold('focus', false));
          document.addEventListener('visibilitychange', () => { if (!document.hidden) this.resume(); });

          // vegen op mobiel
          let startX = null;
          let startY = null;
          panelsEl.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            hold('touch', true);
          }, { passive: true });
          panelsEl.addEventListener('touchend', (e) => {
            if (startX !== null) {
              const dx = e.changedTouches[0].clientX - startX;
              const dy = e.changedTouches[0].clientY - startY;
              if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.index + (dx < 0 ? 1 : -1));
            }
            startX = null;
            hold('touch', false);
          }, { passive: true });

          this.onScroll = () => {
            if (this.scrollTicking) return;
            this.scrollTicking = true;
            requestAnimationFrame(() => {
              this.scrollTicking = false;
              const rect = this.getBoundingClientRect();
              const vh = window.innerHeight || document.documentElement.clientHeight;
              const p = Math.min(1, Math.max(0, (vh - rect.top) / (rect.height + vh)));
              this.style.setProperty('--dawn', p.toFixed(3));

              // terugval voor browsers zonder scroll-timeline: zelfde bereik
              // (cover 8% -> 62%), lineair zoals de CSS
              if (this.night) {
                const r = this.night.getBoundingClientRect();
                const cover = (vh - r.top) / (vh + r.height);
                const x = Math.min(1, Math.max(0, (cover - 0.08) / 0.54));
                const m = Math.min(1, Math.max(0, (cover - 0.08) / 0.77));
                this.night.style.setProperty('--night', x.toFixed(4));
                this.night.style.setProperty('--moon', m.toFixed(4));
              }
            });
          };
          // alleen JS-gestuurd als de browser geen scroll-timeline kent
          const nightEl = this.querySelector('[data-night]');
          this.night = window.CSS && CSS.supports('animation-timeline: view()') ? null : nightEl;

          // eindpunt van de maan: precies boven de quote in de zwarte sectie
          const moonEl = this.querySelector('.hope__moon');
          this.measureMoon = () => {
            const section = this.closest('.shopify-section');
            const next = section && section.nextElementSibling;
            const quote = next && next.querySelector('.lx-parallax__content');
            if (!quote || !moonEl) {
              nightEl.style.removeProperty('--moon-travel');
              return;
            }
            const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
            const startY = nightEl.getBoundingClientRect().top + moonEl.offsetTop;
            const endY = quote.getBoundingClientRect().top - moonEl.offsetHeight - rem * 4.4;
            nightEl.style.setProperty('--moon-travel', Math.max(0, endY - startY).toFixed(1) + 'px');
          };
          this.onResize = () => {
            this.measureMoon();
            this.onScroll();
          };
          this.measureMoon();
          window.addEventListener('load', this.onResize, { once: true });
          if (document.fonts) document.fonts.ready.then(this.onResize);
          if (!this.reduced) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.onScroll();
          } else {
            this.style.setProperty('--dawn', '0.7');
          }

          window.addEventListener('resize', this.onResize, { passive: true });

          this.render();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
          cancelAnimationFrame(this.raf);
          if (this.lineObserver) this.lineObserver.disconnect();
          if (this.viewObserver) this.viewObserver.disconnect();
        }

        setToggleLabel() {
          const label = this.userPaused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause;
          this.toggleBtn.setAttribute('aria-label', label);
          this.toggleBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        }

        isRunning() {
          return !this.userPaused && this.inView && this.holds.size === 0 && !document.hidden;
        }

        go(i) {
          const n = this.panels.length;
          this.index = ((i % n) + n) % n;
          this.elapsed = 0;
          this.render();
          this.resume();
        }

        render() {
          this.tabs.forEach((tab, i) => {
            const active = i === this.index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            tab.style.setProperty('--p', i < this.index ? 1 : 0);
          });
          this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === this.index));
        }

        resume() {
          if (this.raf || !this.isRunning()) return;
          this.last = performance.now();
          const tick = (now) => {
            if (!this.isRunning()) {
              this.raf = null;
              return;
            }
            this.elapsed += now - this.last;
            this.last = now;
            const duration = this.durations[this.index];
            this.tabs[this.index].style.setProperty('--p', Math.min(1, this.elapsed / duration).toFixed(4));
            if (this.elapsed >= duration) {
              this.index = (this.index + 1) % this.panels.length;
              this.elapsed = 0;
              this.render();
            }
            this.raf = requestAnimationFrame(tick);
          };
          this.raf = requestAnimationFrame(tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailers-lespoir"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('retail-story')) {
    customElements.define(
      'retail-story',
      class RetailStory extends HTMLElement {
        connectedCallback() {
          this.reveals = Array.from(this.querySelectorAll('.reveal'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (this.reducedMotion.matches) {
            this.reveals.forEach((el) => el.classList.add('is-visible'));
            return;
          }

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  this.io.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.16, rootMargin: '0px 0px -10% 0px' }
          );
          this.reveals.forEach((el) => this.io.observe(el));
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
